import { AxiosRequestConfig } from 'axios';
import * as qs from 'qs';

/**
 * 人机识别
 */

const origin = window.location.origin;

const getFlag = (url: string = ''): null | number => {
    if (url.indexOf('/v2/order/history/r/query') === 0) {
        return 100007;
    } else if (url.indexOf('/v2/order/history/r/print/info/v2') === 0) {
        return 100009;
    }

    return null;
};

const onFulfilled = (config: AxiosRequestConfig) => {
    const flag = getFlag(config.url);

    if (flag === null) {
        return config;
    } else {
        window.Rohr_Opt.Flag = flag;
        const queryParams = qs.stringify(config.params || {});
        let fullUrl = `${origin}${config.url}`;
        if (queryParams !== '') {
            fullUrl = `${fullUrl}${fullUrl.indexOf('?') > -1 ? '&' : '?'}${queryParams}`;
        }
        if (window.Rohr_Opt.reload) {
            try {
                window.Rohr_Opt.reload(fullUrl);
            } catch (e) {
                // do nothing
            }
        }

        if (config.params) {
            config.params._token = window.rohrdata;
        } else {
            config.params = {
                _token: window.rohrdata,
            };
        }

        return config;
    }
};

export default {
    onFulfilled,
};
